import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import HighIntentOffersCarousel from 'components/OfferList/HighIntent/HighIntentOffersCarousel'
import config from 'constants/config'
import React from 'react'

interface Props {
  highIntentOffers: Array<App.HighIntentOffer>;
}

function TopPicksForMeHighIntentOffers(props: Props) {
  const { highIntentOffers } = props
  if (highIntentOffers.length === 0 || !config.LERE_HIGH_INTENT_CAROUSEL_ENABLED) {
    return null
  }

  return <LayoutContainer>
    <VerticalSpacer gap={16}>
      <Heading variant="heading5">Still interested in these offers?</Heading>
      <HighIntentOffersCarousel highIntentOffers={highIntentOffers} />
    </VerticalSpacer>
  </LayoutContainer>
}
export default TopPicksForMeHighIntentOffers
